import React from 'react';

export default function Button3(props) {
  return (
    <div
      style={{
        background: 'linear-gradient(to right, #56F444, #55EE44, #48FA8A)',
        padding: '8px 32px', // Adjust px-8 py-2
        fontSize: '12px',
        fontWeight: '400',
        borderRadius: '4px',
        cursor: 'pointer',
        textAlign: 'center',
        marginTop: '16px', // Adjust mt-4
        transition: 'all 0.7s ease',
        maxWidth: 'fit-content', // Ensure proper sizing
        margin: 'auto', // Center alignment
      }}
      onMouseOver={(e) => {
        e.target.style.opacity = '0.9'; // Slight hover effect
      }}
      onMouseOut={(e) => {
        e.target.style.opacity = '1';
      }}
    >
      {props.btn3}
    </div>
  );
}
